import _ from 'lodash';

import {
  TMDetail,
  TmDetailByOtherShop,
  TMFastDetail,
  TMBrandList,
  TMEdit,
  TMEdit2,
  TMProductForm,
  submitBrandTask,
  querySubmitBrandResult,
  matchProductSchema,
  getTmProductInfo,
  addProductSchema,
  getAddProductSchema,
  getPublishSchema,
  getTmallTemplateList,
  TMDetailSupplier,
  getTmShopList,
  GetTmImportTemplate,
  getTmProductSimpleConversion,
  getTmDetailSimpleConversion,
} from '@/api/prod/center'
import { PLATFORMS_ICONS } from '@/dictionary/platforms.js'


const formatShopList = (list) => {
    return list.map((item) => {
        if (item.subSource === 'tjb') {
            item.icon = PLATFORMS_ICONS[item.subSource] || PLATFORMS_ICONS.kuaishou;
        } else {
            item.icon = PLATFORMS_ICONS[item.source] || PLATFORMS_ICONS.kuaishou;
        }
        return item;
    });
}

const formatSizeList = (listMap)=>{
    const transformedData = listMap.map(item=>{
        const { sizeMaps, ...reset} = item
        let sizeTitle = []
        const sizeArray = Object.entries(sizeMaps).map(([sizeItem,sizeInfo]) => {
            const {size,...resetSize} = sizeInfo
            sizeTitle = Object.keys({size,...resetSize,})
            return {
                ...sizeInfo,
                size:sizeItem
            }
        });
        return {
            sizeMaps,
            sizeArray,
            sizeTitle,
            ...reset
        }
    })
    return transformedData
}

// 格式化每个商品数据
// isRequest 格式化发送请求数据 --- 默认是格式化响应请求的数据
export function _formatGoodsItem(r, isRequest) {
  if (!isRequest) {
    r.skuList = r.skuList ? JSON.parse(r.skuList) : [] 
  }
  if (r.skuList && r.skuList.length > 0) {
    r.skuList = r.skuList.map(item => {
      return isRequest ? {
        ...item,
        skuSpecifications: JSON.stringify(item.skuSpecifications ? item.skuSpecifications : [])
      } : {
        ...item,
        skuSpecifications: item.skuSpecifications ? JSON.parse(item.skuSpecifications) : []
      }
    })
  }

  return isRequest ? {
    ...r,
    props: JSON.stringify(r.props ? r.props : []),
    itemImgs: JSON.stringify(r.itemImgs ? r.itemImgs : []),
    specifications: JSON.stringify(r.specifications ? r.specifications : []),
    sizeGroup: JSON.stringify(r.sizeGroup ? r.sizeGroup : {}),
    skuList: JSON.stringify(r.skuList)
  } : {
    ...r,
    props: r.props ? JSON.parse(r.props) : [],
    itemImgs: r.itemImgs ? JSON.parse(r.itemImgs) : [],
    specifications: r.specifications ? JSON.parse(r.specifications) : [],
    categoryIds: r.categoryIds ? r.categoryIds.split(',') : [],
    sizeGroup: r.sizeGroup ? JSON.parse(r.sizeGroup) : {},
    skuList: r.skuList ? r.skuList : [],
  }
}

/**
 * 获取天猫商品详情
 * @param {*} params baseitemID
 * @param {*} params shopId
 * @returns 
 */
export const getTmDetail = (params, config = {}) => {
    return TMDetail(params, config).then(res => {
        if (res.result === 1 && res.data) {
            return res.data.map(item => {
                return _formatGoodsItem(item)
            })
        }
        return []
    })
}
/**
 * 获取天猫商品详情（如果TMDetail数据为空，则使用其他店铺的详情数据）
 * @param {*} params baseitemID
 * @param {*} params shopId
 * @param {*} params sourceShopId  从哪家店铺带入资料，可以指定具体，不指定为默认第一个创建此商品资料的店铺
 * @returns 
 */
export const getTmDetailByOtherShop = (params, config = {}) => {
    return TmDetailByOtherShop(params, config).then(res => {
        if (res.result === 1 && res.data) {
            return [_formatGoodsItem(res.data)]
        }
        return []
    })
}
/**
 * 自动一键生成的天猫商品
 * @param {*} params baseitemID
 * @param {*} params shopId
 * @returns 
 */
export const getTmFastDetail = (params) => {
    return TMFastDetail(params).then(res => {
        if (res.result === 1 && res.data) {
            return [_formatGoodsItem(res.data)]
        }
        return []
    })
}

/**
 * 获取天猫商品详情(供销商小店版)
 * @param {*} params baseitemID
 * @returns 
 */
export const getTmDetailSupplier = (params) => {
    return TMDetailSupplier(params).then(res => {
        if (res.result === 1 && res.data) {
            return res.data.map(item => {
                return _formatGoodsItem(item)
            })
        }
        return []
    })
}

/**
 * 获取天猫品牌
 * @param {*} params 
 * @returns 
 */
export const getTmBrandList = (params) => {
    return TMBrandList(params).then(res => {
        if (res.result === 1 && res.data) {
            return res.data
        }
        return []
    })
}

/**
 * 编辑保存
 * @param {*} params 
 * @returns 
 */
export function editTmDetail(params, options = {}) {
    return TMEdit(params.map(item => _formatGoodsItem(item, true)), options).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}
export function editTmDetail2(data,expandParams) {
    let params = {
      itemInfo: _formatGoodsItem(data[0], true),
      ...expandParams
    }
    return TMEdit2(params).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}

/**
 * 获取动态表单
 * @param {*} params 
 * @returns 
 */
export function getProductForm(params) {
    return TMProductForm(params).then(res => {
        if (res.result === 1) {
            return res.data
        } else {
          return false
        }
    }).catch(err => {
      return false
    })
}
// 产品信息无数据时，填充产品信息的接口
export function getProductConversionData(params) {
    return getTmProductSimpleConversion(params).then(res => {
        return res?.data || []
    }).catch(err => {
      return []
    })
}
// 类目属性无数据时，填充类目属性的接口
export function getDetailConversionData(params) {
    return getTmDetailSimpleConversion(params).then(res => {
        return res?.data || []
    }).catch(err => {
      return []
    })
}

// 同步店铺品牌
export const syncShopBrand = (data) => {
    return submitBrandTask(data).then(res => {
        return res.result === 1
    })
}
// 查看店铺品牌同步进度
export const getSyncShopBrandStatus = (data) => {
    return querySubmitBrandResult(data).then(res => {
        if (res.result === 1) {
            return res.data
        } else {
            return false
        }
    })
}

// 铺货第一步的下一步按钮
export const matchHasProductId = (data) => {
    return matchProductSchema(data).then(res => {
        if (res.result === 1) {
            return res.data || []
        } else {
            return false
        }
    })
}
export const getProductInfo = (data) => {
    return getTmProductInfo(data).then(res => {
        if (res.result === 1) {
            return res.data || []
        } else {
            return false
        }
    })
}


// 铺货第二步的下一步按钮
export const step2Fetch = (data) => {
    return addProductSchema(data).then(res => {
        if (res.result === 1) {
            return true
        } else {
            return false
        }
    })
}

// 铺货第二步的schema
export const getProductSchema = (data) => {
    return getAddProductSchema(data).then(res => {
        if (res.result === 1) {
            return res.data
        } else {
            return false
        }
    })
}

// 铺货第二步的下一步按钮
export const getStep3Schema = (data, url, config) => {
    return getPublishSchema(data, url, config).then(res => {
        if (res.result === 1) {
            return res.data
        } else {
            return false
        }
    })
}

// 查询天猫运费模板列表
export const getPostageList = (id) => {
    return getTmallTemplateList({shopId: id}).then(res => {
        if (res.result === 1) {
            return (res.data || []).map(item => ({id: String(item.templateId), templateName: item.name}))
        } else {
            return false
        }
    })
}
// 查询天猫店铺（查询哪个商品的资料完善情况， itemComplete，true表示已完善）
export const queryTmShopList = (data) => {
    return getTmShopList(data).then(res => {
        if (res.result === 1) {
            const data = res.data || [];
            return {
                list: formatShopList(data.list || []),
                page: _.assign({total: data.total || 0}, data.page)
            }
        } else {
            return []
        }
    })
}
/**
 * 获取天猫导入模板数据
 * @param {*} params shopId
 * @returns 
 */
export const getTmImportTemplate = (params) => {
    return GetTmImportTemplate(params).then(res => {
        if (res.result === 1 && res.data) {
            return formatSizeList(res.data)
        }
        return []
    })
}


